import React from "react";

function SpecialOfferHeader() {
  return (
    <header className="flex z-10 flex-col self-center md:mt-[16rem] mt-[80px] max-w-full md:w-[60%] w-[80%] mb-16">
      <h1 
       style={{ letterSpacing: "4px" }}
      className="self-center md:text-[33.85px] text-[17px] font-baloo font-bold text-[#191919] mb-4"> {/* Added mb-4 for bottom spacing */}
        Today <span className="text-red-500">Offers</span> Products
      </h1>
     
    </header>
  );
}

export default SpecialOfferHeader;
